import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_ADVISOR_MANAGEMENT = {
  'list': [],
  'loading': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'company': 'TE',
    'code': '',
    'name': '',
    'dealer': '',
    'status': '',
  },
};

export const advisorManagment = (state, action) => {
  return createReducer(INITIAL_STATE_ADVISOR_MANAGEMENT, {
    [ActionTypes.FETCHING_ADVISOR_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ADVISOR_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ADVISOR_MANAGEMENT_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_ADVISOR_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_ADVISOR_MANAGEMENT,
    }),
  })(state, action);
};

export const advisorManagementForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_ADVISOR_MANAGEMENT_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ADVISOR_MANAGEMENT_INFO]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          'code': action.response.data.code,
          'name': action.response.data.name,
          'dealer': action.response.data.dealer,
          'status': action.response.data.status,
        },
      };
    },
    [ActionTypes.FETCHED_ADVISOR_MANAGEMENT_INFO_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'name': '',
        'dealer': '',
        'status': '',
      },
    }),
    [ActionTypes.CLEAR_ADVISOR_MANAGEMENT_INFO]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'name': '',
        'dealer': '',
        'status': '',
      },
    }),

    [ActionTypes.SET_ADVISOR_INFO_FORM]: (state, action) => {
      const {name, value} = action.payload;
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          [name]: value,
        },
      };
    },

  })(state, action);
};
